<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-基础设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启分销功能">
        <div>
          <el-radio v-model="form.is_open" label="1">开启</el-radio>
          <el-radio v-model="form.is_open" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="分销层级">
        <div>
          <el-radio v-model="form.level" label="1">一级分销</el-radio>
          <el-radio v-model="form.level" label="2">二级分销</el-radio>
          <el-radio v-model="form.level" label="3">三级分销</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="分销商内购">
        <div>
          <el-radio v-model="form.self_buy" label="1">开启</el-radio>
          <el-radio v-model="form.self_buy" label="0">关闭</el-radio>
          <div class="tips">如开启，分销商自己购买商品，获得一级佣金</div>
        </div>
      </el-form-item>
      <el-form-item label="建立关系需要是分销">
        <div>
          <el-radio v-model="form.no_agent" label="1">否</el-radio>
          <el-radio v-model="form.no_agent" label="0">是</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="分销模式">
        <div>
          <el-radio v-model="form.dist_mod" label="1">三级分销模式</el-radio>
          <el-radio v-model="form.dist_mod" label="2">平推和级差模式</el-radio>
          <el-radio v-model="form.dist_mod" label="3">万亿分销模式</el-radio>
        </div>
      </el-form-item>

      <el-form-item label="付款增加业绩">
        <div>
          <el-radio v-model="form.achievement" label="1">开启</el-radio>
          <el-radio v-model="form.achievement" label="0">关闭</el-radio>
          <div class="tips">如开启，自己购买商品，自己与上级获得业绩</div>
        </div>
      </el-form-item>

      <el-form-item label="业绩明细显示模式">
        <div>
          <el-radio v-model="form.achievement_type" label="1">一级（直推）</el-radio>
          <el-radio v-model="form.achievement_type" label="2">二级（间推）</el-radio>
          <el-radio v-model="form.achievement_type" label="3">三级</el-radio>
          <el-radio v-model="form.achievement_type" label="4">无限</el-radio>

        </div> 
      </el-form-item>


      <el-form-item label="开启付款赠送上级积分">
        <div>
          <el-radio v-model="form.open_referee_point" label="1">开启</el-radio>
          <el-radio v-model="form.open_referee_point" label="0">关闭</el-radio>
          <div class="tips">如开启，自己购买商品，上级获得积分</div>
        </div>
      </el-form-item>

      <el-form-item label="开启付款赠送上级积分类型" v-if="form.open_referee_point ==1">
        <div>

          <el-radio v-model="form.referee_point_type" label="0">不选择</el-radio>
          <el-radio v-model="form.referee_point_type" label="1">固定</el-radio>
          <el-radio v-model="form.referee_point_type" label="2">比例</el-radio>
          <div class="tips">采用不选择时，默认按【财务】【积分管理】【积分赠送】【积分赠送比例】的设置进行赠送</div>
        </div>
      </el-form-item>

      <el-form-item label="付款赠送上级积分" v-if="form.referee_point_type != 0 && form.open_referee_point ==1">
        <div>
          
          <el-input v-model="form.referee_point" type="text" class="max-w460"></el-input>
          <span v-if="form.referee_point_type == 1">积分</span>
          <span v-if="form.referee_point_type == 2">%</span>

          <div>
            订单支付金额：99，赠送
            <span v-if="form.referee_point_type == 1">{{ form.referee_point }}</span>
            <span v-if="form.referee_point_type ==  2">{{  getPrice((form.referee_point/100 ) * 99 )}}</span>
   
          </div>
        </div>
      </el-form-item>


      <el-form-item label="分销商显示佣金">
        <div>
          <el-radio v-model="form.show_commission" label="1">开启</el-radio>
          <el-radio v-model="form.show_commission" label="0">关闭</el-radio>
          <div class="tips">如开启，商品显示对应佣金</div>
        </div>
      </el-form-item>

      <el-form-item label="分销佣金文案">
        <el-input v-model="form.direct_commission_text" type="text" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        is_open: '',
        level: '',
        self_buy: '',
        no_agent: '',
        dist_mod: '1',
        achievement:0,
        achievement_type:1,
        show_commission:0,
        direct_commission_text:'',
        open_referee_point:0,
        referee_point_type:0,
        referee_point:0,
      },
      /*是否正在加载*/
      loading: false
    };
  },
  props:{
    settingData:Object
  },
  created() {

    this.form=this.settingData.data.basic.values;
  },
  methods: {
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        return this.roundToDecimalPlace(price,2)
      },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      PlusApi.basic(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Basic.vue